import { FC } from "react"

interface IProps {
  point: number[]
}
const Polyline: FC<IProps> = ({ point }) => {
  return (
    <svg width="830" height="200" xmlns="http://www.w3.org/2000/svg">
      <polyline
        points={point.join(" ")}
        fill="none"
        stroke="#404040"
        stroke-width="1"
      />
    </svg>
  )
}

export default Polyline
